import React from "react";

/* ─── SVG Icons ─────────────────────────────────────────────── */
const DiamondIcon = () => (
  <svg style={{ margin: "0 auto" }} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
    <path d="M12 2L2 9l10 13L22 9 12 2z" />
    <path d="M2 9h20" />
  </svg>
);

const RocketIcon = () => (
  <svg style={{ margin: "0 auto" }} width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
  </svg>
);

/* ─── Pin component ─────────────────────────────────────────── */
const Pin = () => (
  <div style={{
    width: 22, height: 22, borderRadius: "50%",
    background: "radial-gradient(circle at 35% 35%, #ef4444, #991b1b)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    flexShrink: 0,
  }} />
);

/* ─── Pinned Card ───────────────────────────────────────────── */
const PinnedCard = ({ title, text, icon, rotate = "-2deg", pinLeft = true }) => (
  <div style={{
    position: "relative",
    background: "#ffffff",
    borderRadius: 18,
    padding: "32px 28px 28px",
    // boxShadow: "0 4px 32px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.05)",
    boxShadow: "17.0857px 29.0456px 46.1313px rgba(240, 143, 7, 0.06)",
    
    transform: `rotate(${rotate})`,
    maxWidth: 400,
    width: "100%",
    fontFamily: "'Poppins', sans-serif",
  }}>
    <div style={{
      position: "absolute", top: 20,
    }}>
      <Pin />
    </div>
    <div style={{ marginBottom: 10 }}>{icon}</div>
    <h3 style={{ fontWeight: 700, fontSize: "1.05rem", color: "#111827", marginBottom: 12 }}>
      {title}
    </h3>
    <p style={{ fontStyle: "italic", fontSize: "0.8rem", color: "#6B7280", lineHeight: 1.75, textAlign: "center" }}>
      {text}
    </p>
  </div>
);

/* ─── Step item ─────────────────────────────────────────────── */
const Step = ({ number, title, text, align = "left", mobileNumber }) => (
  <div style={{
    fontFamily: "'Poppins', sans-serif",
    maxWidth: 220,
    textAlign: align,
    position: "relative",
  }}>
    {/* Ghost number — desktop */}
    <div className="step-ghost-number" style={{
      position: "absolute",
      top: 20, left: -65,
      fontSize: "5rem", fontWeight: 900,
      color: "rgba(0,0,0,0.10)",
      lineHeight: 1,
      userSelect: "none", pointerEvents: "none",
    }}>
      {number}
    </div>
    <h4 style={{ fontWeight: 700, fontSize: "0.88rem", color: "#111827", marginBottom: 8, position: "relative" }}>
      {title}
    </h4>
    <p style={{ fontSize: "0.75rem", color: "#6B7280", lineHeight: 1.75, textAlign: "justify" }}>
      {text}
    </p>
  </div>
);

/* ─── Mobile Step Card ──────────────────────────────────────── */
const MobileStep = ({ number, title, text }) => (
  <div style={{
    display: "flex", gap: 16,
    fontFamily: "'Poppins', sans-serif",
  }}>
    {/* Number bubble */}
    <div style={{
      flexShrink: 0,
      width: 36, height: 36,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #129ADC, #B55DD0)",
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#fff", fontWeight: 700, fontSize: "0.85rem",
      marginTop: 2,
    }}>
      {number}
    </div>
    <div>
      <h4 style={{ fontWeight: 700, fontSize: "0.88rem", color: "#111827", marginBottom: 6 }}>
        {title}
      </h4>
      <p style={{ fontSize: "0.75rem", color: "#6B7280", lineHeight: 1.75 }}>
        {text}
      </p>
    </div>
  </div>
);

/* ─── Curved SVG path ───────────────────────────────────────── */
const CurvedPath = () => (
  <svg
    viewBox="0 0 900 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: "100%", height: "auto",
      position: "absolute", top: "-15vh", left: 0,
      pointerEvents: "none",
      // filter: `
      //   drop-shadow(0 0 8px rgba(0,0,0,0.42))
      //   drop-shadow(0 4px 16px rgba(0,0,0,0.10))
      //   drop-shadow(0 8px 30px rgba(0,0,0,0.08))
      // `,
    }}
  >
    <defs>
      <linearGradient id="pathGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#129ADC" />
        <stop offset="50%" stopColor="#B55DD0" />
        <stop offset="100%" stopColor="#F45A39" />
      </linearGradient>
    </defs>
    <path
      d="M 40 150 C 120 50, 180 80, 280 100 C 380 110, 400 110, 500 60 C 600 0, 640 30, 760 50 C 840 80, 880 0, 900 0"
      stroke="url(#pathGrad)" strokeWidth="2.5" strokeLinecap="round" fill="none"
    />
    {[{ cx: 40, cy: 150 }, { cx: 280, cy: 100 }, { cx: 500, cy: 60 }, { cx: 760, cy: 50 }].map((dot, i) => (
      <g key={i}>
        <circle cx={dot.cx} cy={dot.cy} r="8" fill="#fff" stroke="#E5E7EB" strokeWidth="1.5" />
        <circle cx={dot.cx} cy={dot.cy} r="3" fill="#ef4444" />
      </g>
    ))}
  </svg>
);

const steps = [
  {
    number: "1",
    title: "We Don't Do 'Just Design'",
    text: "We don't just make things look good, we make them work. Every design is built with clarity, purpose, and real business impact in mind.",
  },
  {
    number: "2",
    title: "No Guesswork, Only Strategy",
    text: "No random colors, no 'let's try this' approach. Every decision is backed by structure, logic, and what actually works for your brand.",
  },
  {
    number: "3",
    title: "We Care Like It's Our Own Brand",
    text: "We treat your brand like it's ours — paying attention to every detail, from pixels to performance.",
  },
  {
    number: "4",
    title: "Clean, Modern and Scroll Stopping",
    text: "Because let's be honest – if it doesn't catch attention in 2 seconds, it's already ignored.",
  },
];

/* ─── Main Section ──────────────────────────────────────────── */
const VisionMissionSection = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap');

        .vm-section {
          background: #F8F8F8;
          font-family: 'Poppins', sans-serif;
          overflow: hidden;
        }

        /* ── Cards area ── */
        .cards-area {
          display: flex;
          justify-content: center;
          gap: 48px;
          flex-wrap: wrap;
          padding: 100px 32px;
          max-width: 80rem;
          margin: 0 auto;
          text-align: center;
        }

        /* ── Why area ── */
        .why-area {
          background: #F8F8F8;
          padding: 64px 56px 80px;
          position: relative;
          
        }

        .why-label {
          font-size:20px;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: 0em;
          text-transform: uppercase;
          background: linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 10px;
          width: fit-content; 
        }

        .why-heading {
          font-weight: 700;
          font-size: 36px;
          color: #111827;
          line-height: 40px;
          margin: 0 0 24px;
          max-width: 600px;
        }

        .cta-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #111827;
          border-radius: 100px;
          padding: 10px 22px;
          cursor: pointer;
          background: transparent;
          transition: border-color 0.2s, box-shadow 0.2s;
          margin-bottom: 64px;
        }
        .cta-btn:hover {
        }

        /* ── Desktop steps (curved path layout) ── */
        .steps-path-container {
          position: relative;
          width: 100vw;
          height: 320px;
        }
        .steps-grid {
          position: absolute;
          inset: 0;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          align-items: end;
        }
        .step-col-1 { align-self: end; padding-bottom: 0; padding-left: 60px;}
        .step-col-2 { align-self: center; padding-left: 30px;}
        .step-col-3 { align-self: flex-start; padding-top: 36px; padding-left: 60px; }
        .step-col-4 { align-self: flex-start; padding-top: 0; padding-left: 60px;}

        /* ── Mobile steps (vertical list) ── */
        .steps-mobile {
          display: none;
          flex-direction: column;
          gap: 28px;
        }

        /* ── Breakpoint: ≤ 767px ── */
        @media (max-width: 767px) {
          .cards-area {
            flex-direction: column;
            align-items: center;
            padding: 48px 24px 56px;
            gap: 36px;
          }
          /* straighten cards on mobile — tilted cards clip on narrow screens */
          .cards-area > div {
            transform: none !important;
          }
          .why-area {
            padding: 48px 24px 56px;
          }
          .cta-btn {
            margin-bottom: 40px;
          }
          /* hide desktop curved path layout */
          .steps-path-container {
            display: none;
          }
          /* show mobile vertical list */
          .steps-mobile {
            display: flex;
          }
        }

        /* ── Breakpoint: 768px – 1023px (tablet) ── */
        @media (min-width: 768px) and (max-width: 1023px) {
          .cards-area {
            padding: 56px 32px 64px;
            gap: 36px;
          }
          .why-area {
            padding: 56px 40px 72px;
          }
          .step-ghost-number {
            display: none;
          }
        }
      `}</style>

      <div className="vm-section">

        {/* ── Part 1: Vision & Mission Cards ── */}
        <div className="cards-area">
          <PinnedCard
            title="Our Vision"
            icon={<DiamondIcon />}
            rotate="9deg"
            pinLeft={true}
            text="To build a new standard of modern design where brands are not just visually appealing, but strategically crafted to stand out, build trust, and grow in the digital world."
          />
          <PinnedCard
            title="Our Mission"
            icon={<RocketIcon />}
            rotate="9deg"
            pinLeft={false}
            text="To help startups and businesses build strong, consistent, and high-performing brands through thoughtful design, modern UI/UX, and impactful visual communication."
          />
        </div>

        {/* ── Part 2: Why Choose SINTX ── */}
        <div className="why-area">
      <div className="sub" style={{ maxWidth: "80rem", margin: "0 auto", }}>
          <p className="why-label">WHY CHOOSE SINTX</p>
          <h2 className="why-heading">
            Because your brand deserves<br />more than average.
          </h2>

          <button className="cta-btn" onClick={() => { document.getElementById("contact").scrollIntoView({ behavior: "smooth" }); }} style={{ background: "#EBEBEB" }}>
            Get a Free Review <span style={{ fontSize: "1rem" }}>↗</span>
          </button>
      </div>
          {/* ── DESKTOP: curved path + floating steps ── */}
          <div className="steps-path-container">
            <CurvedPath />
            <div className="steps-grid">
              <div className="step-col-1">
                <Step number="1" title={steps[0].title} text={steps[0].text} align="left" />
              </div>
              <div className="step-col-2">
                <Step number="2" title={steps[1].title} text={steps[1].text} align="left" />
              </div>
              <div className="step-col-3">
                <Step number="3" title={steps[2].title} text={steps[2].text} align="left" />
              </div>
              <div className="step-col-4">
                <Step number="4" title={steps[3].title} text={steps[3].text} align="left" />
              </div>
            </div>
          </div>

          {/* ── MOBILE: vertical numbered list ── */}
          <div className="steps-mobile">
            <div className="steps-mobile-inner">
              {steps.map((s) => (
                <MobileStep key={s.number} number={s.number} title={s.title} text={s.text} />
              ))}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default VisionMissionSection;